import type { Jast } from '@atlaskit/jql-ast';
import { substring } from './common';

/**
 * Adds a new clause to an AST's jql.
 *
 * values that are string[] are automatically wrapped in ()
 */
const addClause = (
	ast: Jast,
	jqlClauseFn: (arg1: string) => string,
	valueOrValues: string | string[],
): string => {
	const santizedValue = Array.isArray(valueOrValues)
		? `(${valueOrValues.join(',')})`
		: valueOrValues;

	const jqlClause = jqlClauseFn(santizedValue);

	const jqlString = ast.represents;
	if (ast.query) {
		if (ast.query.where) {
			if (ast.query && ast.query.orderBy && ast.query.orderBy.position) {
				const [orderByStartPosition] = ast.query.orderBy.position;
				const whereClause = substring(jqlString, 0, orderByStartPosition);
				const orderByClause = substring(jqlString, orderByStartPosition);
				return `${whereClause}${
					whereClause.trim().length > 0 ? 'AND ' : ''
				}${jqlClause} ${orderByClause}`;
			}
			return `${jqlString}${jqlString.trim().length > 0 ? ' AND ' : ''}${jqlClause}`;
		}
		return `${jqlClause}${jqlString.trim().length > 0 ? ` ${jqlString}` : ''}`;
	}
	return jqlString;
};

export default addClause;
